/* External */
import { useMemo } from 'react';

import { Npaw } from '@dtvgo/player-utils';

/* Utils */
import platform from '../utils/platform';

export default function useNpawError(error) {
  return useMemo(() => Npaw.errorParser(platform.platformName, error), [error]);
}
